import AppRPE from './AppRPE';

export default AppRPE;